import { FC, ReactNode } from 'react';
import { Alert, AlertRootProps } from '@chakra-ui/react';

interface AppBannerProps extends Omit<AlertRootProps, 'status' | 'children'> {
  message: string | ReactNode;
  status?: 'info' | 'warning' | 'success' | 'error';
  title?: string;
}

export const AppBanner: FC<AppBannerProps> = ({
  message,
  status = 'info',
  title,
  ...rest
}) => (
  <Alert.Root
    alignItems="center"
    borderRadius="md"
    justifyContent="center"
    py={2}
    status={status}
    textAlign="center"
    variant="subtle"
    {...rest}
  >
    <Alert.Indicator />
    <Alert.Content>
      <Alert.Title fontWeight="medium">
        {title ? `${title}: ` : ''}
        {message}
      </Alert.Title>
    </Alert.Content>
  </Alert.Root>
);
